import React from 'react';
import { Input, Button } from 'tg-core-components';
import cn from 'classnames';
import {
  validateRules,
  required,
  email,
  externalEmailValidation,
} from '../../validation';
import { getContinueLabel } from '../../helpers';

import translate from 'tg-core-components/lib/lib/utils/translate';

const Email = ({
  /* Props from parent */
  errors,
  onChange,
  intl,
  fields,
  isLoading,
  nextStep,
  statuses,

  /* Props from selector */
  device,
}) => {
  const isValid = statuses.Email === 'success';

  return (
    <form onSubmit={e => (isValid ? nextStep() : e.preventDefault())}>
      <Input
        autoFocus
        type="email"
        label={translate({ id: 'label.email', defaultMessage: 'Email' }, intl)}
        value={fields.Email}
        name="Email"
        onChange={(_, Email) => onChange({ Email })}
        status={(isLoading && 'loading') || statuses.Email}
        statusText={errors.Email && translate({ id: errors.Email }, intl)}
      />

      <Button
        disabled={!isValid}
        className={cn('continue primary', {
          'continue--valid': isValid,
        })}>
        {getContinueLabel(device)}
      </Button>
    </form>
  );
};

const validate = async ({ Email }, jurisdiction) => {
  const rules = {
    Email: [
      [required, 'error.empty.email'],
      [email, 'error.condition.email'],
      [externalEmailValidation(jurisdiction), 'errors.taken.email'],
    ],
  };
  const errors = await validateRules({ Email }, rules);

  return Promise.resolve({ errors });
};

const selector = state => ({
  device: state.app.device,
});

export default {
  name: 'email',
  icon: 'envelope',
  Component: Email,
  validate,
  selector,
  fields: ['Email'],
};
